import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

  contentViewPort: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.white.efesBackgroundLight,
    marginTop: 30,
  },
  contentContainer: {
    maxWidth: 1360,
    margin: '0 auto',
    width: '100%',
    [theme.breakpoints.down(1920)]: {
      maxWidth: 1360,
    },
    [theme.breakpoints.down(1660)]: {
      maxWidth: 1200,
    },
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.gray.efesGray,
  },
  topFooterContainer: {
    padding: 0,
    paddingTop: 40,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 30,
      paddingRight: 12,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 20,
      paddingLeft: 12,
    },
  },
  topFooterParentBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: 5,
  },
  efesLogo: {
    width: 100,
  },
  calculators: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
    },
  },
  item: {
    '& p': {
      fontSize: 16,
      color: theme.palette.blue.efesDarkBlue,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    '& ul': {
      color: theme.palette.gray.efesGrayish,
      padding: 0,
      listStyleType: 'none',
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
      '& li': {
        marginBottom: 10,
        '& a': {
          color: 'unset',
          '&:hover': {
            color: theme.palette.black.main,
          },
        },
      },
    },
  },
  footerActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 28,
    width: 256,
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      '& button': {
        width: '100%',
      },
    },
  },
  links: {
    display: 'flex',
    width: '60%',
    justifyContent: 'space-between',
    [theme.breakpoints.down(1381)]: {
      flexWrap: 'wrap',
      width: '40%',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      flexWrap: 'nowrap',
    },
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& button': {
      width: '100%',
      height: 48,
    },
  },
  mobileLanguage: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.gray.efesGrayish,
    },
  },
  mobileButtonGroup: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      marginBottom: 24,
      marginTop: 12,
    },
    '& button': {
      width: '100%',
      height: 48,
    },
  },
  logoSection: {
    display: 'flex',
    flexDirection: 'column',

    '& p': {
      fontSize: 9,
      marginTop: 16,
      marginBottom: 16,
      marginLeft: 10,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
  },
  logos: {
    display: 'flex',
    flexDirection: 'column',
  },
  top: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-evenly',
    },
  },
  bottom: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: 10,
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-evenly',
      marginLeft: 0,
    },
  },
  compensationItem: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: 'auto',
      fontSize: 14,
    },
  },
  bottomFooter: {
    margin: '0 auto',
    maxWidth: 1200,
  },
  bottomFooterContainer: {
    paddingTop: 15,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 15,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
    color: theme.palette.gray.efesGrayish,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [theme.breakpoints.down('sm')]: {
      gap: 20,
      paddingLeft: 20,
    },
  },
  homePageLanguage: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  language: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
    },
  },
  homePageCopyRight: {
    color: theme.palette.black.main,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      width: '100%',
      justifyContent: 'center',
      order: 2,
    },
  },
  copyRight: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      order: 3,
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      fontSize: 10,
    },
  },
  homePageSocialLinks: {
    display: 'flex',
    gap: '1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      flexBasis: '100%',
      justifyContent: 'center',
    },
  },
  socialLinks: {
    display: 'flex',
    gap: '1rem',
  },
}));

export default useStyles;
